import * as types from 'containers/pages/customers/constants';
import { CustomerFormData } from 'containers/pages/customers/types';

interface CustomerAction {
  type: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: any;
}

const customerFormReducer = (state: CustomerFormData, action: CustomerAction): CustomerFormData => {
  switch (action.type) {
    case types.RESET:
    case types.CUSTOMER_CONVERT:
      return action.payload;
    default:
      if (action.type in state) {
        return { ...state, [action.type]: action.payload };
      }
      return state;
  }
};

export default customerFormReducer;
